import { gql } from '@apollo/client'
export const queryFeedbackConfigList = gql`
query Query($name: String $page: Int!, $count: Int!) {
  feedbackConfigList(name: $name, page: $page, count: $count) {
    data {
      id
      level1Name
      deviceModel
      issueType
      isValid
      createdAt
      updatedAt
      subLevel {
        key
        display
      }
    }
    total
  }
}
`
